module.exports = __webpack_public_path__ + "eb1416e02baeee91a39f721e871caf23.svg";